export default "__VITE_ASSET__14509702__"